import { getDefaultSuboption } from '../getDefaultSubOption';
import { matchVariantsByVisualValue } from '../variants/matchVariants';
// @ts-ignore
import * as apparelSorter from '../apparel-sorter';

import { buildIValueLabelPairFromValue } from '../attributes/buildIValueLabelPairFromValue';
import { matchAttribute } from '../attributes/matchAttribute';
import { ISelectedSubOptions } from 'src/components/ProductList/interfaces/ISelectSubOption';

export const getAllSizesForVariant = (
  productId: string,
  variant: GQL.IProductVariant,
  products: Array<GQL.IProduct>,
  sizeAttributes: Array<GQL.IAttribute>,
  language: string,
  selectedSubOptions: ISelectedSubOptions
) => {
  const sizes = new Array<string>();

  const product = products.find(p => p.id == productId);
  if (product == undefined || !product.variants) {
    return undefined;
  }

  let sizeAttribute: GQL.IAttribute | undefined;

  const relevantVariants = [ ...product.variants ];

  if (!relevantVariants.some(v => v.id == variant.id)) {
    relevantVariants.unshift(variant);
  }

  for (const v of relevantVariants) {
    sizeAttribute = matchAttribute(v, sizeAttributes);
    if (sizeAttribute != undefined) {
      break;
    }
  }

  if (sizeAttribute == undefined) {
    return undefined;
  }

  for (const v of relevantVariants) {
    const tempValueId = (v.definition || {})[ sizeAttribute.id ];
    if (tempValueId && (v.inStock > 0 || product.status !== 3)) {
      const value = (sizeAttribute.values || []).find(val => val.id == tempValueId);
      const subOption = (selectedSubOptions[ sizeAttribute.id ] || getDefaultSuboption(sizeAttribute) || '').toUpperCase();
      if (value) {
        const size = buildIValueLabelPairFromValue(value, language, subOption, sizeAttribute).label;
        if (size) {
          sizes.push(size);
        }
      }
    }
  }

  return apparelSorter.sort(sizes);
};



// WEBPACK FOOTER //
// ./src/helpers/products/getAllSizesForVariants.ts